module.exports = __webpack_public_path__ + "components/MapControl/svg/Poczta.svg?a1623721";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Poczta.svg
// module id = 2075
// module chunks = 0